import React from 'react';

import SectionListingHeading from './ListingPageSections/SectionListingHeading';
import SectionAboutEquipment from './ListingPageSections/SectionAboutEquipment';
import SectionListingTabs from './ListingPageSections/SectionListingTabs';
import { isTrailerListing } from '../../util/listingPageContent';

/**
 * Main listing content sections shown in the left column (below gallery).
 *
 * @component
 */
const ListingPageMainContent = props => {
  const {
    title,
    description,
    showDescription,
    publicData,
    listing,
    config,
    geolocation,
    author,
  } = props;

  const isTrailer = isTrailerListing(publicData, config.categoryConfiguration);

  return (
    <>
      <SectionListingHeading
        title={title}
        publicData={publicData}
        categoryConfiguration={config.categoryConfiguration}
        author={author}
        listingId={listing?.id?.uuid}
      />

      {showDescription ? (
        <SectionAboutEquipment description={description} isTrailer={isTrailer} />
      ) : null}
    </>
  );
};

export default ListingPageMainContent;
